import { Component, OnInit } from '@angular/core';
import { AuthService } from "../../services/auth.service";
import { Router } from "@angular/router";
import {FormBuilder, FormGroup, ReactiveFormsModule, Validators} from "@angular/forms";
import {MatInputModule} from "@angular/material/input";
import {MatProgressBarModule} from "@angular/material/progress-bar";
import {NgIf} from "@angular/common";
import {BackButtonComponent} from "../../../core/back-button/back-button.component";
import {MatButtonModule} from "@angular/material/button";
import {ErrorPanelComponent} from "../../../core/error-panel/error-panel.component";
import {ActionsContainerComponent} from "../../../core/actions-container/actions-container.component";
import {QuickPreviewPanelComponent} from "../../../core/quick-preview-panel/quick-preview-panel.component";


@Component({
  selector: 'auth-user-reset-password',
  templateUrl: './reset-password.component.html',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    MatInputModule,
    MatProgressBarModule,
    NgIf,
    BackButtonComponent,
    MatButtonModule,
    ErrorPanelComponent,
    ActionsContainerComponent,
    QuickPreviewPanelComponent
  ]
})
export class ResetPasswordComponent implements OnInit {

  loading = false
  error?: any
  formGroup: FormGroup

  constructor(
    readonly fb: FormBuilder,
    readonly authService: AuthService,
    readonly router: Router,) {
    this.formGroup = this.fb.group({
      'oldPassword': ['', Validators.required],
      'newPassword': ['', Validators.required],
      'newPasswordConfirm': ['', Validators.required],
    }, {
      validators: [this.checkPasswords]
    })
  }

  ngOnInit(): void {
  }


  checkPasswords(group: FormGroup) {
      const pass = group.controls['newPassword'].value;
      const confirmPass = group.controls['newPasswordConfirm'].value;

      return pass === confirmPass ? null : { confirmMismatch: true };
  }

  submit(): void {
    if (this.formGroup.valid) {
      const formValue: { newPassword: string, oldPassword: string} = this.formGroup.value
      this.loading = true
      this.error = undefined
      this.authService.resetPassword(formValue.oldPassword, formValue.newPassword).subscribe({
        next: (r) => {
          console.info('success', r)
          this.loading = false
          this.authService.logout()
        },
        error: (e) => {
          console.error('Error resetting password', e)
          this.loading = false
          this.error = e
        }
      })
    }
  }
}
